export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13553.7c8fbda9.jpg";